import * as Types from "src/Constants/Types";

export const setCurrentPage = (value: number) => ({
  type: Types.SET_CURRENT_PAGE as "SET_CURRENT_PAGE",
  value,
});

export const setPreviousPage = (value: number) => ({
  type: Types.SET_PREVIOUS_PAGE as "SET_PREVIOUS_PAGE",
  value,
});
